import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import FormControl from "react-bootstrap/FormControl"
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Categories from './Categories';
import moment from 'moment';
import { useEffect, useState } from "react";


function MyVerticallyCenteredModal(props) {
  const [feeling, setFeeling] = useState("")
  const [category, setCategory] = useState("")
  const [fight_id, setFight_id] = useState("")
  const [fights, setFights] = useState([])
  const [selectedFight, setSelectedFight] = useState("");
  

  const [newFightTopic, setNewFightTopic] = useState("");
  const [isCreatingNewFight, setIsCreatingNewFight] = useState(false);
  useEffect(()=>{
    if(props.selectedFight){
        setFight_id(props.selectedFight.fight_id)
        setCategory(props.selectedFight.category)
        setNewFightTopic(props.selectedFight.topic)
        setFeeling(props.selectedFight.fights[0].feeling)
    } else {
        setFight_id("")
        setCategory("")
        setNewFightTopic("")
        setFeeling("")
    }

  }, [props.selectedFight])


  const handleSubmit = async () => {
    // Prepare feeling data
    const feelingData = {
      start_date: moment(props.date).format("YYYY-MM-DD"),
      end_date: moment(props.date).format("YYYY-MM-DD"),
      feeling,
      category,
      user_id: props.session.user.id,
      fight_id: fight_id,
    };
    
    if(!props.selectedFight){
      
          const newFightData =  {
                topic: newFightTopic,
                category:category,
                user_id: props.session.user.id,
                start_date: moment(props.date).format("YYYY-MM-DD"),
              }
      
            
          await props.onSubmit({ feelingData, newFightData });
      
          setFeeling("");
          setNewFightTopic("");
          setSelectedFight("");
          setFight_id("");
          setIsCreatingNewFight(false);
    } else {
        props.handleUpdate({ ...feelingData,...props.selectedFight, topic: newFightTopic, category: category})
    }
  };


  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          (ง•̀_•́)ง
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
{/*         
        <div style={{ marginBottom: "15px" }}>
          <label>Select a fight:</label>
          <DropdownButton
            id="dropdown-fight-select"
            title={selectedFight
              ? fights.find(f => f.fight_id === selectedFight)?.topic || "Select a fight"
              : "Select a fight"}
            onSelect={handleSelectFight}
            variant="secondary"
          >
            {fights.map(fight => (
              <Dropdown.Item key={fight.fight_id} eventKey={fight.fight_id}>
                {fight.topic}
              </Dropdown.Item>
            ))}
            <Dropdown.Divider />
            <Dropdown.Item eventKey="new">+ Create a new fight</Dropdown.Item>
          </DropdownButton>
        </div> */}

         
          <div style={{ marginTop: "10px" }}>
            <input
              type="text"
              placeholder="New fight topic"
              value={newFightTopic}
              onChange={(e) => setNewFightTopic(e.target.value)}
              className="form-control"
              required
              disabled={props.selectedFight}
            />
          </div>
        

        <div style={{ display: 'flex', justifyContent: "center", marginTop: "10px" }}>
          <FormControl
            as="textarea"
            placeholder='Dear Diary,'
            onChange={(e) => setFeeling(e.target.value)}
            value={feeling}
          />

        </div>
        <div>
          <br />
          <Categories onSelect={(value) => setCategory(value)} value={category} />
        </div>

        <div style={{ display: 'flex', justifyContent: "center", marginTop: "10px" }}>
          <Button
            disabled={!feeling || (isCreatingNewFight && !newFightTopic)} 
            variant='dark'
            onClick={handleSubmit}
            > {props.selectedFight ? "Update" : "Add "}  (ง•̀_•́)ง</Button>
        </div>
      </Modal.Body>

    </Modal>
  );
}

export default MyVerticallyCenteredModal;